// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!

/* tslint:disable */
export const VERSION = {
  version: "7.2.1",
  date: "2026-07-06T14:43:16.497Z",
  gitInfo: {
    dirty: false,
    raw: "c1a2d7a24",
    hash: "c1a2d7a24",
    distance: null,
    tag: null,
    semver: null,
    suffix: "c1a2d7a24",
    semverString: null
  }
};
/* tslint:enable */
